import React from 'react';
import style from './style.module.scss';
import Icon from 'components/Icon';
import {IProductSnippet} from 'shared/types/productSnippet.types';
import {Ratings} from './Ratings';
import {Stickers} from 'components/ProductSnippetNew/components/ProductSnippetHeader/GalleryOverlayBar/Features/Stickers';

type TStickersProps = Pick<IProductSnippet, 'ratings' | 'isFineAndRare' | 'reviewsUrl' | 'reviewsCount' | 'stickers'> &
    Pick<IProductSnippet['analytics'], 'onReviewsClick'> & {
        isFirstImageActive?: boolean;
    };

export const Features = (props: TStickersProps) => {
    const {
        isFineAndRare,
        ratings,
        reviewsCount,
        reviewsUrl,
        stickers,
        onReviewsClick,
        isFirstImageActive = true,
    } = props;

    return (
        <div className={style.main}>
            {isFineAndRare && <Icon className={style.fineAndRareIcon} icon={'fineandrare'} />}
            {!isFineAndRare && isFirstImageActive && (
                <Ratings
                    ratings={ratings}
                    reviewsUrl={reviewsUrl}
                    reviewsCount={reviewsCount}
                    onReviewsClick={onReviewsClick}
                />
            )}
            <Stickers stickers={stickers} />
        </div>
    );
};
